<template>
  <div>
    <div class="view-framework">
    	<userLeft></userLeft>
    	<div class="view-framework-body">
    		<div class="view-framework-main">
    			<div class="box">
    				<h2 class="box-caption">销卡统计</h2>
    				<div class="table-responsive">
              <div class="status-form text-center">
                <el-date-picker
                	v-model="value2"
                	type="daterange"
                	align="center"
                	unlink-panels
                	range-separator="至"
                	start-placeholder="起始日期"
                	end-placeholder="结束日期"
                	:picker-options="pickerOptions"
                	:editable="false"
                	size='small'
                	@change='optionData'
                	value-format="yyyy-MM-dd">
                </el-date-picker>
                <el-select v-model="orderType" placeholder="请输入卡种" size='small'
                @change="StatisticsRecord"
                :remote-method="getList"
                :loading="loading"
                filterable
                remote
                reserve-keyword>
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.goods_name"
                      :value="item.id">
                    </el-option>
                </el-select>
              </div>
              <div class="status-main">
                <div class="status-main-item">
                  <i class="iconfont icon-qiaquanquan"></i>
                  <div class="qwfqfgbbb">
                    <div class="hinef">成功卡数</div>
                    <div class="h8">{{statisticsList.order_success_count}}</div>
                  </div>
                </div>
                <div class="status-main-item">
                  <i class="iconfont icon-dkw_jine"></i>
                  <div class="qwfqfgbbb">
                    <div class="hinef">成功金额</div>
                    <div class="h8">{{statisticsList.order_success_money}}</div>
                  </div>
                </div>
                <div class="status-main-item">
                  <i class="iconfont icon-dingdanshibai"></i>
                  <div class="qwfqfgbbb">
                    <div class="hinef">失败卡数</div>
                    <div class="h8">{{statisticsList.order_error_count}}</div>
                  </div>
                </div>
                <div class="status-main-item">
                  <i class="iconfont icon-shuliang"></i>
                  <div class="qwfqfgbbb">
                    <div class="hinef">提现笔数</div>
                    <div class="h8">{{statisticsList.withdrawal_count}}</div>
                  </div>
                </div>
                <div class="status-main-item">
                  <i class="iconfont icon-jine"></i>
                  <div class="qwfqfgbbb">
                    <div class="hinef">提现金额</div>
                    <div class="h8">{{statisticsList.withdrawal_money}}</div>
                  </div>
                </div>
              </div>
    				</div>
    			</div>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {

              picker.$emit('pick', [new Date(), new Date()]);
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
          ]
        },
        value2:[],
        dataFirst:"",
        dataLast:"",
        orderType:"",
        options:[],
        statisticsList:{},
        loading:false
      }
    },
    created(){
      this.StatisticsRecord()
    },
    methods:{
      getList(e){
        this.loading = true
        this.$api.searchDetail({
          goods_name:e
        })
        .then(result => {
          this.loading = false
          this.options = result.data
        })
      },
      optionData(){
      	this.dataFirst = this.value2[0] + ' ' + '00:00:00'
      	this.dataLast = this.value2[1] + " " + "23:59:59"
        this.StatisticsRecord()
      },
      StatisticsRecord(){
        this.$api.StatisticsRecord({
					satrttime:this.dataFirst,
					endtime:this.dataLast,
					cate_id:this.orderType
        })
        .then(result => {
          this.statisticsList = result.data
        })
      }
    }
  }
</script>

<style scoped>
.status-main{
  display: flex;
  align-items: center;
  flex-wrap: wrap;

}
.status-main-item{
  width: calc(100% / 3);
  text-align: center;
  margin-top: 20px;
}
.status-main-item i{
  font-size: 80px;
  color: #70bb3c;
}
.status-main-item .h8{
  font-size: 25px;
  font-weight: bold;
}
.status-main-item .hinef{
  color: #b3b3b3;

}
.qwfqfgbbb{
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/statistics.vue